import { useQuery } from '@tanstack/react-query';
import { getAllDomains } from '../services/domain-warmup';

export const useGetAllDomain = () => {
  return useQuery(['domain-warmup'], getAllDomains, {
    initialData: { data: [] },
  });
};
